import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceDetailsFormViewProps } from "models/propTypes/invoicePropTypes";
import { InvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import InvoiceAmountSection from "./detailSections/amounts";
import InvoiceDateSection from "./detailSections/dates";
import InvoiceDimensionSection from "./detailSections/dimension";
import InvoiceGeneralSection from "./detailSections/general";
import InvoicePaymentDetailSection from "./detailSections/paymentDetails";
import InvoiceReminderSection from "./detailSections/reminders";
import RecurringInvoiceDateSection from "./detailSections/recurringDates";
import InvoicePeriodSection from "./detailSections/periods";
import { useWintForm, WintForm } from "components/common/wintForms";
//#endregion

const InvoiceDetailsForm: ForwardRefRenderFunction<FormHandles, InvoiceDetailsFormViewProps> = (props, ref) => {
  const { wintFormProps, connect, values } = useWintForm<InvoiceFormTypes.Details>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
    handleSubmit: props.handleSubmit,
    enableReinitialize: true,
  });

  const { invoice, currency, isRecurring, dimensionAmount, isAutomaticRemindersFeatureEnabled, loadInvoice, fileViewer } = props;

  return (
    <WintForm {...wintFormProps}>
      <InvoiceGeneralSection invoice={invoice} values={values} />
      <InvoiceAmountSection currency={currency} values={values} />
      {isRecurring ? <RecurringInvoiceDateSection values={values} /> : <InvoiceDateSection values={values} />}
      <InvoiceReminderSection
        values={values}
        invoice={invoice}
        isRecurring={isRecurring}
        isAutomaticRemindersFeatureEnabled={isAutomaticRemindersFeatureEnabled}
      />
      <InvoicePaymentDetailSection invoice={invoice} values={values} />
      {!isRecurring && (
        <InvoiceDimensionSection
          invoice={invoice}
          currency={currency}
          dimensionAmount={dimensionAmount}
          values={values}
          connect={connect}
        />
      )}
      <InvoicePeriodSection
        invoice={invoice}
        isRecurring={isRecurring}
        values={values}
        loadInvoice={loadInvoice}
        fileViewer={fileViewer}
      />
    </WintForm>
  );
};

export default forwardRef(InvoiceDetailsForm);
